class CartRemoveButton extends HTMLElement {
    constructor() {
        super(), this.addEventListener("click", (e => {
            e.preventDefault(), this.closest("cart-items").updateQuantity(this.dataset.index, 0)
        }))
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status"), this.cartErrors = document.getElementById("cart-errors"), this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(((e, t) => e + parseInt(t.value)), 0), this.debouncedOnChange = debounce((e => {
            this.onChange(e)
        }), 300), this.addEventListener("change", this.debouncedOnChange.bind(this))
    }
    onChange(e) {
        null !== e.target && this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"))
    }
    getSectionsToRender() {
        let e = [{
            id: "mini-cart",
            section: document.getElementById("mini-cart")?.id,
            selector: ".shopify-section"
        }, {
            id: "main-cart-items",
            section: document.getElementById("main-cart-items")?.dataset.id,
            selector: ".js-contents"
        }, {
            id: "cart-icon-bubble",
            section: "cart-icon-bubble",
            selector: ".shopify-section"
        }, {
            id: "mobile-cart-icon-bubble",
            section: "mobile-cart-icon-bubble",
            selector: ".shopify-section"
        }, {
            id: "cart-live-region-text",
            section: "cart-live-region-text",
            selector: ".shopify-section"
        }, {
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer")?.dataset.id,
            selector: ".js-contents"
        }];
        return document.querySelector("#main-cart-footer .free-shipping") && e.push({
            id: "main-cart-footer",
            section: document.getElementById("main-cart-footer")?.dataset.id,
            selector: ".free-shipping"
        }), e
    }
    updateQuantity(e, t, i) {
        this.enableLoading(e);
        const n = this.getSectionsToRender().map((e => e.section)),
            s = JSON.stringify({
                line: e,
                quantity: t,
                sections: n,
                sections_url: window.location.pathname
            });
        fetch(`${theme.routes.cart_change_url}`, {
            ...fetchConfig(),
            body: s
        }).then((e => e.text())).then((t => {
            const n = JSON.parse(t);
            this.classList.toggle("is-empty", 0 === n.item_count);
            const s = document.getElementById("main-cart-footer");
            s && s.classList.toggle("is-empty", 0 === n.item_count), n.errors && this.updateErrorLiveRegions(e, n.errors), this.getSectionsToRender().forEach((e => {
                const t = document.getElementById(e.id);
                if (t) {
                    const i = t.querySelector(e.selector) || t;
                    i && n.sections[e.section] && (i.innerHTML = this.getSectionInnerHTML(n.sections[e.section], e.selector))
                }
            })), this.updateQuantityLiveRegions(e, n.item_count);
            const r = document.getElementById(`CartItem-${e}`);
            r && i && r.querySelector(`[name="${i}"]`).focus(), this.disableLoading(), document.dispatchEvent(new CustomEvent("cart:updated", {
                detail: {
                    cart: t
                }
            })), publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "cart-items"
            })
          
            new Swiper('.empty-cart-recommendations-slider', {
                loop: false,
                navigation: {
                    nextEl: `.swiper-button-next`,
                    prevEl: `.swiper-button-prev`,
                },
                slidesPerView: 1.5,
                paginationClickable: true,
                spaceBetween: 15,
                breakpoints: {
                    749: {
                        slidesPerView: 2.7
                    },
                    450: {
                        slidesPerView: 3
                    },
                },
            });
        })).catch((() => {
            this.querySelectorAll(".loading-overlay").forEach((e => e.classList.add("hidden"))), this.disableLoading(), this.cartErrors && (this.cartErrors.textContent = theme.cartStrings.error)
        }))
    }
    updateErrorLiveRegions(e, t) {
        const i = document.getElementById(`Line-item-error-${e}`) || document.getElementById(`CartDrawer-LineItemError-${e}`);
        i && (i.querySelector(".cart-item__error-text").innerHTML = t), this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const n = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        n.setAttribute("aria-hidden", !1), setTimeout((() => {
            n.setAttribute("aria-hidden", !0)
        }), 1e3)
    }
    updateQuantityLiveRegions(e, t) {
        if (this.currentItemCount === t) {
            const t = document.getElementById(`Line-item-error-${e}`);
            t && (t.querySelector(".cart-item__error-text").innerHTML = theme.cartStrings.quantityError.replace("[quantity]", document.getElementById(`Quantity-${e}`).value))
        }
        this.currentItemCount = t, this.lineItemStatusElement && this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const i = document.getElementById("cart-live-region-text");
        i && (i.setAttribute("aria-hidden", !1), setTimeout((() => {
            i.setAttribute("aria-hidden", !0)
        }), 1e3))
    }
    getSectionInnerHTML(e, t) {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t)?.innerHTML
    }
    enableLoading(e) {
        const t = document.getElementById("main-cart-items");
        t && t.classList.add("cart__items--disabled");
        const i = this.querySelectorAll(".loading-overlay")[e - 1];
        i && i.classList.remove("hidden"), document.activeElement.blur(), this.lineItemStatusElement && this.lineItemStatusElement.setAttribute("aria-hidden", !1)
    }
    disableLoading() {
        const e = document.getElementById("main-cart-items");
        e && e.classList.remove("cart__items--disabled")
    }
    renderContents(e) {
        this.getSectionsToRender().forEach((t => {
            const i = document.getElementById(t.id);
            i && (i.innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector))
        }))
    }
}
customElements.define("cart-items", CartItems);
class CartNote extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", debounce((e => {
            const t = JSON.stringify({
                note: e.target.value
            });
            fetch(`${theme.routes.cart_update_url}`, {
                ...fetchConfig(),
                body: t
            })
        }), 300))
    }
}
customElements.define("cart-note", CartNote);
class DiscountCode extends HTMLElement {
    constructor() {
        super(), isStorageSupported("session") && (this.setupDiscount(), this.addEventListener("change", (e => {
            window.sessionStorage.setItem("discount", e.target.value)
        })))
    }
    setupDiscount() {
        const e = window.sessionStorage.getItem("discount");
        null !== e && (this.querySelector('input[name="discount"]').value = e)
    }
}
customElements.define("discount-code", DiscountCode);
class ShippingCalculator extends HTMLElement {
    constructor() {
        super(), this.setupCountries(), this.errors = this.querySelector("#ShippingCalculatorErrors"), this.success = this.querySelector("#ShippingCalculatorSuccess"), this.zip = this.querySelector("#ShippingCalculatorZip"), this.country = this.querySelector("#ShippingCalculatorCountry"), this.province = this.querySelector("#ShippingCalculatorProvince"), this.button = this.querySelector("button"), this.button.addEventListener("click", this.onSubmitHandler.bind(this))
    }
    setupCountries() {
        Shopify && Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector("ShippingCalculatorCountry", "ShippingCalculatorProvince", {
            hideElement: "ShippingCalculatorProvinceContainer"
        })
    }
    onSubmitHandler(e) {
        e.preventDefault(), this.errors.classList.add("hidden"), this.success.classList.add("hidden"), this.zip.classList.remove("invalid"), this.country.classList.remove("invalid"), this.province.classList.remove("invalid"), this.button.classList.add("loading"), this.button.setAttribute("disabled", !0);
        const t = JSON.stringify({
            shipping_address: {
                zip: this.zip.value,
                country: this.country.value,
                province: this.province.value
            }
        });
        let i = `${theme.routes.cart_url}/shipping_rates.json`;
        i = i.replace("//", "/"), fetch(i, {
            ...fetchConfig("javascript"),
            body: t
        }).then((e => e.json())).then((e => {
            if (e.shipping_rates) this.success.classList.remove("hidden"), this.success.innerHTML = "", e.shipping_rates.forEach((e => {
                const t = document.createElement("p");
                t.innerHTML = `${e.name}: ${e.price} ${Shopify.currency.active}`, this.success.appendChild(t)
            }));
            else {
                let t = [];
                Object.entries(e).forEach((([e, i]) => {
                    t.push(`${e.charAt(0).toUpperCase()+e.slice(1)} ${i[0]}`)
                })), this.errors.classList.remove("hidden"), this.errors.querySelector(".errors").innerHTML = t.join("; ")
            }
        })).catch((e => {
            console.error(e)
        })).finally((() => {
            this.button.classList.remove("loading"), this.button.removeAttribute("disabled")
        }))
    }
}
customElements.define("shipping-calculator", ShippingCalculator);